'use strict';

var _ = require('lodash');

function ContainerController ($animate, $q, $scope, $interval) {

  var vm = this;
  var buttons = [];
  
  var DEFAULTS = {
    delay: 0,
    show: true,
    stack: undefined,
  };

  /**
   * Called by the directive to initilialize the controller
   */
  vm.init = function () {
    _.defaults(this, DEFAULTS);
    vm.delay = parseInt(vm.delay);
  };

  vm.register = function (id, buttonCtrl) {
    buttons.push(buttonCtrl);

    if (vm.delay) {
      buttonCtrl.show = false;
      vm.showButtons();
    }
  };

  /**
   * Hide the buttons. If delay is specified then the removal of each button will 
   * be staggered by  the specified delay.
   * 
   * @param  {[type]} ignoreDelay [description]
   * @return {Promise}
   */
  vm.hideButtons = function (ignoreDelay) {
    var len = buttons.length;
    var deferred = $q.defer();
    var interval = null;

    if (!len) {
      return;
    }

    if (vm.delay && !ignoreDelay) {
      interval = $interval(function () {
        var buttonCtrl = buttons[len-1];
        buttonCtrl.show = false;
        len--;

        if (len === 0) {
          $interval.cancel(interval);
          deferred.resolve();
        }
      }, vm.delay);
    } else {
      _.forEach(buttons, function (buttonCtrl) {
        buttonCtrl.show = false;
      });

      deferred.resolve();
    }

    return deferred.promise;
  };

  /**
   * showButtons
   *
   * @description  If delay is specified then the appearance of each button will 
   * be staggered by the specified delay. Debounced so that it is only triggered 
   * once if called in rapid succession like during registration.
   */
  vm.showButtons = _.debounce(function () {
    var index = 0;
    var interval = null;
    var len = buttons.length;

    if (vm.delay) {
      interval = $interval(function () {
        if (index >= len) {
          $interval.cancel(interval);
        } else {
          var buttonCtrl = buttons[index];
          buttonCtrl.show = true;
          index++;
        }
      }, vm.delay);
    } else {
      _.forEach(buttons, function (buttonCtrl) {
        buttonCtrl.show = true;
      });
    }
  }, 10);

  //////////////////////////////////////////////////////////////////////////////////////////////
  // Helpers
  //////////////////////////////////////////////////////////////////////////////////////////////


  /**
   * Used internally to retrieve a specified controller attribute
   * 
   * @param  {String} attr
   * @return {*}
   */
  var ctrlAttr = function (attr) {
    return function () {
      return this[attr];
    }.bind(this);
  }.bind(this);

  /**
   * Removes text nodes from the node list
   * 
   * @param  {Array} nodes array of nodes
   */
  // var getButtons = function (nodes) {
  //   var buttons = _.chain(nodes)
  //     .filter(function (node) {
  //       return node.nodeType === 1;
  //     })
  //     .value();

  //   return buttons;
  // }.bind(this);


  //////////////////////////////////////////////////////////////////////////////////////////////
  // Event Handlers
  //////////////////////////////////////////////////////////////////////////////////////////////
  
  var onToggleShow = function (newVal, oldVal) {
    if (newVal !== oldVal) {
      if (!newVal) {
        vm.hideButtons();
      } else {
        vm.showButtons();
      }
    }
  }.bind(this);

  $scope.$watch(ctrlAttr('show'), onToggleShow);
}

module.exports = ContainerController;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/button/src/buttonContainer/ButtonContainerController.js